import { z } from "zod";
import { SlotId } from "./slot-id.js";

// isolatedDeclarations: annotate the shape type explicitly so tsc can emit declarations
// without reading across module boundaries. We define the output shape as a TS interface
// and use z.ZodType<Output> on the exported const.
export interface Widget {
  instanceId: string;
  templateId: string;
  name: string;
  placement: SlotId;
  config: unknown;
}

export const Widget: z.ZodType<Widget> = z.strictObject({
  instanceId: z.string().min(1),
  templateId: z
    .string()
    .min(1)
    .regex(/^[a-z][a-z0-9-]*$/, "kebab-case"),
  name: z.string().min(1).max(100),
  placement: SlotId,
  config: z.unknown(),
});
